import React, { useEffect, useState } from "react";
import { Form, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, InputCheck, CancelButton, ButtonComponent, ModalComponent, trans } from "@comps/components"
import { makeRequest } from "@utils/helpers";
import { updateDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { PlusCircleOutlined } from "@ant-design/icons";
import CreateExpression from "./CreateExpression";
import { payrollHelpText } from "../../../payrollHelpText";
import { makeFieldLabel } from "@utils/fieldTooltips";
const langKey = Const["formula"].lngKey
const formName = "createFormula";
const formulaLabel = makeFieldLabel(payrollHelpText.formula, { namespace: formName, label: (key) => trans(`${langKey}.${key}`) });
const UpdateFormula = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [childComponent, setChildComponent] = useState(false);
  const [form] = Form.useForm()
  const [expression, setExpression] = useState('');
  const [isValid, setIsValid] = useState(true)
  useEffect(() => {
    setData()
    // eslint-disable-next-line
  }, []);

  const setData = () => {
    form.setFieldsValue(
      props.record
    )
    setExpression(props.record.expression)
  }

  const onSubmit = (data) => {
    if (expression === '' || expression === null) {
      message.error('Please enter a valid expression')
      return
    }

    setsaving(true)
    const payload = {
      id: props.record.id,
      formula: {
        ...props.record,
        name: data.name,
        expression: expression,
        is_salary_division: data.is_salary_division,
        description: data.description,
      }
    };
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {

    message.success(res.message);
    props.onCompleted(data.formulas.data);
  }

  const onError = (err, res) => {

    setsaving(false)
    message.error(res.response.data.message);
  }

  const onCreateExpression = () => {
    const options = {
      exclude: null,
      formulas: true,
      payitems: true,
      rules: null
    }
    setChildComponent(<CreateExpression onCompleted={ onCompleted } record={ expression } isValid={ isValid } options={ options } />)
  }

  const onCompleted = (data, isValid) => {
    if (data) {
      setExpression(data)
      setIsValid(isValid)
    }

    setChildComponent(null)
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    props.disabled ? '' :
      <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } disabled={ props.disabled }>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ formulaLabel('name', trans(Commons.name)) }
              className="da-mb-16"
            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="expression" label={ formulaLabel('expression') }
              className="da-mb-16"

            >
              <div className="expression-field">
                <InputTextArea placeholder={ trans(`${langKey}.expression`) } disabled={ true } value={ expression } />
                <ButtonComponent className="expression-field-btn" onClick={ onCreateExpression } icon={ <PlusCircleOutlined /> } />
              </div>
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="is_salary_division" rules={ rules.is_salary_division } label={ formulaLabel('is_salary_division') }
              className="da-mb-16"
              valuePropName="checked"
            >
              <InputCheck />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="description" rules={ rules.description } label={ formulaLabel('description') }
              className="da-mb-16"
            >
              <InputTextArea placeholder={ trans(`${langKey}.description`) } />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  )
}

export default UpdateFormula

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],
  expression: [
    { required: true, message: trans(`${langKey}.expression.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
